<template>
  <div class="Expander">
    <div role="tablist" aria-multiselectable="true" class="custaccordian">
      <div class="card">
        <div class="card-header" role="tab" id="headingOne">
          <h5 class="mb-0">
            <a @click="toggle" data-toggle=""
               data-parent="#filteraccordian" :href="'#' + id" aria-expanded="false" :aria-controls="id">{{ title
              }} <span 
                class="dselect">{{ subtitle }}</span>
            </a>
          </h5>
        </div>
        <div :id="id" class="maxer card-detail collapse" :class="{'in':expand}"  role="tabpanel" aria-labelledby="headingOne">
          <slot ></slot>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  export default {
    name: 'Expander',
    props: ['title', 'subtitle'],
    data () {
      return {
        id: 'collapse-' + Math.trunc(Math.random() * 99999).toString(16),
        expand: window.matchMedia('(min-width: 767px)').matches && this.title.toLowerCase() === ('Products').toLowerCase()
      }
    },
    methods: {
      toggle (event) {
        event.preventDefault()
        this.expand = !this.expand
      }
    }
  }
</script>

<style scoped>
  .activewear-landing .maxer, .supima-landing .maxer {
    background-color: #f1f2f2;
  }
  .dselect {
    width: 115px;
  }

  .in {
    display: block;
  }

  .stickyfilter {
    position: fixed;
    top: 85px;
  }

  .childAccordian .card {
    border-bottom: 0;
  }

  .childAccordian .card a {
    border-bottom: 0;
    padding: 10px 0;
    text-transform: inherit;
    font-family: 'Source Sans Pro', sans-serif;
    font-weight: 400;
    color: #000 !important;
  }

  .custaccordian .card-header a[aria-expanded="false"]:before, .custaccordian .mbFaqheader a[aria-expanded="false"]:before,
  .custaccordian .card-header a[aria-expanded="true"]:before, .custaccordian .mbFaqheader a[aria-expanded="true"]:before {
    top: 5px;
  }
  .activewear-landing  .custaccordian .card-header a[aria-expanded="false"]:before {
    content: "\f0d7";
  }
  .activewear-landing  .custaccordian .card-header a[aria-expanded="true"]:before {
    content: "\f0d8";
  }
  .activewear-landing  .custaccordian .card-header a {
    color: #000 !important;
    font-family: 'Oswald Demi Bold Italic';
  }
  .supima-landing  .custaccordian .card-header a[aria-expanded="false"]:before {
    content: "\f0d7";
  }
  .supima-landing  .custaccordian .card-header a[aria-expanded="true"]:before {
    content: "\f0d8";
  }
  .supima-landing  .custaccordian .card-header a {
    color: #000 !important;
    font-family: 'Oswald Demi Bold Italic';
  }

  .custaccordian .childAccordian .card-header a[aria-expanded="true"]:before,
  .custaccordian .childAccordian .card-header a[aria-expanded="false"]:before {
    top: 4px;
  }

  .customcheckbox [type="checkbox"]:not(:checked) + label:before, .customcheckbox [type="checkbox"]:checked + label:before {
    top: 6px;
  }


  @media screen and (max-width: 991px) {
    .childAccordian {
      padding: 0 10px;
    }
    .custaccordian .card-detail {
      padding: 0 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// vue-accordian.vue?2dd23f55